@if (showMenu()) {
  <app-main-layout>
    <div
      class="flex justify-center items-center h-screen fixed top-0 left-0 right-0 bottom-0 bg-white opacity-75 z-[10001]"
      [ngClass]="{'hidden' : !isSpinning()}">
      <ui-spinner [isLoading]="isSpinning()" />
    </div>
    <router-outlet></router-outlet>
  </app-main-layout>
} @else {
  <router-outlet></router-outlet>
}

